// extracted by mini-css-extract-plugin
module.exports = {"root":"InstalmentFields_root__1ezqS"};